import __prm from '@/calc_params.json';


export default {
  install(Vue, options) {


  	var loanPrm = [];

  	// config parser, fill loan params
    if (typeof __prm == 'object') {

        let t, i, o, a;

        for (t in __prm) {
            if (__prm.hasOwnProperty(t)) {
                for (i in __prm[t]) {
                    if (__prm[t].hasOwnProperty(i)) {

                        o = String(i).split('_');
                        a = String(o[0].replace('-', '.') * 100);

                       

                        // init
                        loanPrm [o[1]] = loanPrm [o[1]] || [];

                        loanPrm [o[1]][ a ] = __prm[t][i];
                    }
                }
            }
        }

    }

  	Vue.prototype.loan_params = loanPrm;

  },
};


// WEBPACK FOOTER //
// ./src/plugins/loan-params.js